<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 text-xs-center>
        <v-stepper v-model="currentStep" vertical>
          <v-stepper-step
            @click="setStepper(1)"
            step="1"
            edit-icon="person"
            complete-icon="email"
            editable
            >Customer/Company Details</v-stepper-step
          >
          <v-stepper-content step="1">
            <v-form>
              <v-flex xs12 sm8 md4>
                <v-text-field
                  dense
                  label="Customer/Company name*"
                  outlined
                  v-model="company.name"
                ></v-text-field>
                <v-text-field
                  dense
                  label="Customer/Company email"
                  outlined
                  v-model="company.email"
                  :error="!!companyErrorMessages.length"
                  :error-messages="companyErrorMessages"
                ></v-text-field>
                <v-text-field
                  dense
                  label="Customer/Company phone #"
                  outlined
                  v-model="company.phoneNumber"
                ></v-text-field>
                <v-combobox
                  v-model="company.assignedReps"
                  :items="associates"
                  label="Assigned Reps"
                  :item-text="associateName"
                  item-value="_id"
                  multiple
                  outlined
                  dense
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :key="JSON.stringify(data.item._id)"
                      v-bind="data.attrs"
                    >
                      <v-avatar
                        class="primary"
                        left
                        v-text="data.item.lastName.slice(0, 1).toUpperCase()"
                      ></v-avatar>
                      {{ data.item.lastName }}, {{ data.item.firstName }}
                    </v-chip>
                  </template>
                </v-combobox>
                <v-textarea
                  textarea
                  dense
                  outlined
                  label="Notes"
                  auto-grow
                  rows="4"
                  v-model="company.notes"
                />
              </v-flex>
            </v-form>
          </v-stepper-content>
          <v-stepper-step @click="setStepper(2)" step="2" editable
            >Shipping Addresses</v-stepper-step
          >
          <v-stepper-content step="2">
            <v-layout column v-if="!company.shippingAddresses.length">
              <div>You can setup shipping addresses now or add them later.</div>
            </v-layout>
            <v-layout v-else>
              <v-list two-line>
                <v-list-item-group
                  v-model="selected"
                  active-class="primary--text"
                  multiple
                >
                  <template
                    v-for="(address, index) in company.shippingAddresses"
                  >
                    <v-list-item :key="index">
                      <template v-slot:default="{ active }">
                        <v-list-item-content>
                          <v-list-item-title
                            v-text="address.name"
                          ></v-list-item-title>
                          <v-list-item-subtitle
                            class="text--primary"
                            v-text="address.formatted_address"
                          ></v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action
                          @click="removeAddress(index, 'shipping')"
                        >
                          <v-icon color="primary"> delete </v-icon>
                        </v-list-item-action>
                      </template>
                    </v-list-item>

                    <v-divider
                      v-if="index < company.shippingAddresses.length - 1"
                      :key="index"
                    ></v-divider>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-layout>
            <v-layout>
              <div class="mt-4 mb-4">
                <v-btn
                  @click="setAddAddress('shippingAddresses')"
                  color="primary"
                  >Add Shipping Address</v-btn
                >
              </div>
            </v-layout>
          </v-stepper-content>
          <v-stepper-step @click="setStepper(3)" step="3" editable
            >Billing Addresses</v-stepper-step
          >
          <v-stepper-content step="3">
            <v-layout column v-if="!company.billingAddresses.length">
              <div>You can setup billing addresses now or add them later.</div>
            </v-layout>
            <v-layout v-else>
              <v-list two-line>
                <v-list-item-group
                  v-model="selected"
                  active-class="primary--text"
                  multiple
                >
                  <template
                    v-for="(address, index) in company.billingAddresses"
                  >
                    <v-list-item :key="index">
                      <template v-slot:default="{ active }">
                        <v-list-item-content>
                          <v-list-item-title
                            v-text="address.name"
                          ></v-list-item-title>
                          <v-list-item-subtitle
                            class="text--primary"
                            v-text="address.formatted_address"
                          ></v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action
                          @click="removeAddress(index, 'billing')"
                        >
                          <v-icon color="primary">delete</v-icon>
                        </v-list-item-action>
                      </template>
                    </v-list-item>

                    <v-divider
                      v-if="index < company.billingAddresses.length - 1"
                      :key="index"
                    ></v-divider>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-layout>
            <v-layout>
              <div class="mt-4 mb-4">
                <v-btn
                  @click="setAddAddress('billingAddresses')"
                  color="primary"
                  >Add Billing Address</v-btn
                >
              </div>
            </v-layout>
          </v-stepper-content>

          <v-stepper-step @click="setStepper(4)" step="4" editable
            >Users</v-stepper-step
          >
          <v-stepper-content step="4">
            <v-layout column v-if="!company.users.length">
              <div>You can add users now now or add them later.</div>
            </v-layout>
            <v-layout v-else>
              <v-list two-line>
                <v-list-item-group
                  v-model="selected"
                  active-class="primary--text"
                  multiple
                >
                  <template v-for="(user, index) in company.users">
                    <v-list-item :key="index">
                      <template v-slot:default="{ active }">
                        <v-list-item-content>
                          <v-list-item-title
                            v-text="`${user.firstName} ${user.lastName}`"
                          ></v-list-item-title>
                          <v-list-item-subtitle
                            class="text--primary"
                            v-text="user.email"
                          ></v-list-item-subtitle>
                          <v-list-item-subtitle
                            class="text--primary"
                            v-text="user.phoneNumber"
                          ></v-list-item-subtitle>
                          <v-list-item-subtitle
                            class="text--primary"
                            v-text="user.title"
                          ></v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action @click="removeUser(index)">
                          <v-icon color="primary">delete</v-icon>
                        </v-list-item-action>
                      </template>
                    </v-list-item>

                    <v-divider
                      v-if="index < company.users.length - 1"
                      :key="index"
                    ></v-divider>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-layout>
            <v-layout>
              <div class="mt-4 mb-4">
                <v-btn @click="userModal = true" color="primary"
                  >Add User</v-btn
                >
              </div>
            </v-layout>
          </v-stepper-content>

          <v-stepper-step @click="setStepper(5)" step="5" editable
            >Customer Pricing</v-stepper-step
          >
          <v-stepper-content step="5">
            <v-form>
              <v-tabs child-flex>
                <v-tab left>Category / Subcategory Markups</v-tab>
                <v-tab left>Individual Product Pricing</v-tab>
                <v-tab-item>
                  <v-flex xs12 sm4 mt-6>
                    <div
                      v-for="(category, index) in productCategories"
                      :key="category._id"
                    >
                      <v-layout>
                        <v-flex xs12 sm8 md4>
                          <v-subheader>{{ category.name }}</v-subheader>
                        </v-flex>
                        <v-flex xs12 sm8 md4>
                          <v-text-field
                            outlined
                            dense
                            value="1.5"
                            min="1.01"
                            v-model="productCategories[index].value"
                            type="number"
                          />
                        </v-flex>
                      </v-layout>
                      <div
                        v-if="
                          category.subcategories &&
                          category.subcategories.length
                        "
                      >
                        <h5 class="offset-sm-1">Subcategories:</h5>
                        <v-layout
                          v-for="(subcategory, idx) in category.subcategories"
                          :key="subcategory._id"
                          class="offset-sm-1"
                        >
                          <v-flex xs12 sm8 md4>
                            <v-subheader>{{ subcategory.name }}</v-subheader>
                          </v-flex>
                          <v-text-field
                            type="number"
                            dense
                            outlined
                            value="1.5"
                            min="1.01"
                            v-model="
                              productCategories[index].subcategories[idx].value
                            "
                          />
                        </v-layout>
                      </div>
                    </div>
                  </v-flex>
                </v-tab-item>
                <v-tab-item>
                  <v-layout ml-2 wrap>
                    <v-flex child-flex xs12 sm4 md8 v-if="showProducts" mt-6>
                      <products-table
                        :headers="productTableHeaders"
                        :actions="productTableActions"
                      />
                    </v-flex>
                    <v-flex xs12 sm8 md4>
                      <v-card class="ml-2 elevation-0">
                        <v-list three-line>
                          <div
                            v-for="(
                              item, index
                            ) in company.individualProductPrices"
                            :key="index"
                          >
                            <v-list-item three-line>
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ item.productCode }}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                  {{ item.manufacturer }}
                                </v-list-item-subtitle>

                                <v-list-item-subtitle>
                                  {{ item.description[0].value }}
                                </v-list-item-subtitle>
                                <v-list-item-subtitle>
                                  <v-radio-group
                                    v-model="item.priceSelection"
                                    mb-0
                                    pb-0
                                  >
                                    <v-layout align="center">
                                      <v-radio
                                        label="Markup"
                                        value="customMarkup"
                                      ></v-radio>
                                      <v-text-field
                                        v-model="item.markup"
                                        :readonly="
                                          item.priceSelection === 'customPrice'
                                        "
                                        :disabled="
                                          item.priceSelection === 'customPrice'
                                        "
                                        type="number"
                                        min="1.01"
                                        class="ml-6 mb-4"
                                      ></v-text-field>
                                    </v-layout>
                                    <v-layout align="center">
                                      <v-radio
                                        label="Custom Price"
                                        value="customPrice"
                                      ></v-radio>
                                      <v-text-field
                                        prefix="$"
                                        type="number"
                                        min="1.01"
                                        v-model="item.customPrice"
                                        :readonly="
                                          item.priceSelection === 'customMarkup'
                                        "
                                        :disabled="
                                          item.priceSelection === 'customMarkup'
                                        "
                                        class="ml-6 mb-4"
                                      ></v-text-field>
                                    </v-layout>
                                  </v-radio-group>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-icon @click="removeMarkup(index)">
                                <v-icon color="error">delete</v-icon>
                              </v-list-item-icon>
                            </v-list-item>
                            <v-divider
                              v-if="
                                index + 1 <
                                company.individualProductPrices.length
                              "
                            />
                          </div>
                          <v-list-item
                            v-if="!company.individualProductPrices.length"
                          >
                            <v-list-item-content>
                              <v-list-item-title>
                                No individual product prices yet.
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-tab-item>
              </v-tabs>
              <v-layout></v-layout>
            </v-form>
          </v-stepper-content>
          <v-stepper-step @click="setStepper(6)" step="6" editable
            >Confirm</v-stepper-step
          >
          <v-stepper-content step="6">
            <v-flex text-sm-center mt-4>
              If everything looks good, click SUBMIT to finish adding your
              customer!
            </v-flex>
            <v-layout column mt-12>
              <v-flex text-sm-center>
                <v-btn
                  :disabled="!validCustomer"
                  @click="submit"
                  color="primary"
                >
                  Submit
                  <v-icon right>thumb_up</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-stepper-content>

          <v-layout pb-4 pr-4 pl-4>
            <v-btn
              class="mr-6"
              v-if="currentStep > 1"
              @click="previousStep"
              color="primary"
              >Back</v-btn
            >
            <v-btn v-if="currentStep < 6" @click="nextStep" color="primary"
              >Continue</v-btn
            >
          </v-layout>
        </v-stepper>
      </v-flex>
    </v-layout>
    <add-markup-modal
      v-if="addMarkupModal"
      title="Add Individual Product Pricing"
      :addMarkupModal.sync="addMarkupModal"
      :product="productMarkup"
      @setProductPrice="setProductPrice"
    />

    <address-modal
      v-if="addressModal"
      :title="addressModalTitle"
      :addressModal.sync="addressModal"
      :address="activeAddress"
      :distributors="distributors"
      :options="commonEmails"
      @save="addAddress"
    />
    <user-modal
      v-if="userModal"
      :userModal.sync="userModal"
      title="Add User"
      :selectCustomer="false"
      @save="addUser"
    />
  </div>
</template>

<script>
import request from "@/modules/request";
import { assign, get } from "lodash";
import stepperMixin from "../../../mixins/stepperMixin";
import isValidEmail from "@/modules/isValidEmail";
import EmailSelector from "@/components/shared/EmailSelector";
import SetDistributors from "@/pages/associate/customers/SetDistributors";
import AddMarkupModal from "@/components/shared/modals/AddMarkupModal";
import ProductsTable from "@/components/ProductsTable";
import Table from "@/components/Table";
import AddressModal from "@/components/shared/modals/AddressModal";
import UserModal from "@/components/shared/modals/UserModal";

export default {
  name: "AddCustomer",
  inject: ["snackBar"],
  async mounted() {
    await this.retrieveCategories();
    await this.getDistributors();
    await this.getAssociates();
  },
  mixins: [stepperMixin],
  components: {
    ProductsTable,
    AddMarkupModal,
    AddressModal,
    UserModal,
  },
  data() {
    return {
      addressType: null,
      addressAction: null,
      addressModal: false,
      activeAddress: null,
      associates: [],
      companyErrorMessages: [],
      userErrorMessages: [],
      addMarkupModal: false,
      productMarkup: false,
      showProducts: true,
      userModal: false,
      company: {
        name: null,
        email: null,
        billingAddresses: [],
        shippingAddresses: [],
        users: [],
        notes: null,
        categoryMarkups: [],
        subcategoryMarkups: [],
        individualProductPrices: [],
      },
      productCategories: [],
      orderStatusAlerts: [],
      distributorSettings: [],
      distributors: [],
      productTableHeaders: [
        {
          text: "Product ID",
          value: "productCode",
        },
        {
          text: "Manufacturer",
          value: "manufacturer",
        },
        {
          text: "Category",
          value: "category.name",
        },
        {
          text: "Description",
          value: "description[0].value",
        },
        {
          text: "Cost",
          value: "invoicePrice",
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      productTableActions: [
        {
          color: "primary",
          click: this.setMarkupModal,
          text: "",
          icon: "add",
        },
      ],
    };
  },
  computed: {
    commonEmails() {
      const { users, email } = this.company;
      const emails = {
        orderCreated: [],
        orderStatusUpdated: [],
      };

      if (isValidEmail(email)) {
        emails.orderCreated.push({
          email,
          event: "order-created",
        });

        emails.orderStatusUpdated.push({
          email,
          event: "order-status-updated",
        });
      }

      users.forEach((user) => {
        if (user.email && isValidEmail(user.email)) {
          emails.orderCreated.push({
            email: user.email,
            event: "order-created",
          });

          emails.orderStatusUpdated.push({
            email: user.email,
            event: "order-status-updated",
          });
        }
      });

      return emails;
    },
    addressModalTitle() {
      return this.addressAction === "editing"
        ? "Update Address"
        : "Add Address";
    },
    validProductCategories() {
      const productCategories = this.productCategories || [];
      if (!productCategories.length) return false;

      return productCategories.every((category) => {
        if (category.subcategories && category.subcategories.length) {
          return (
            category.value &&
            category.value > 1 &&
            category.subcategories.every((subcategory) => {
              return subcategory.value && subcategory.value > 1;
            })
          );
        } else {
          return category.value && category.value > 1;
        }
      });
    },
    validCustomer() {
      const { company, companyErrorMessages, validProductCategories } = this;

      return (
        company.name &&
        (company.email ? isValidEmail(company.email) : true) &&
        !companyErrorMessages.length &&
        validProductCategories
      );
    },
  },
  methods: {
    removeUser(index) {
      this.company.users.splice(index, 1);
    },
    removeAddress(index, addressType) {
      const type =
        addressType === "shipping" ? "shippingAddresses" : "billingAddresses";
      this.company[type].splice(index, 1);
    },
    addUser(user) {
      this.company.users.push(user);
      this.userModal = false;
    },
    addAddress(address) {
      const { addressAction, addressType } = this;
      this.addressModal = false;

      if (addressAction === "adding") {
        this.company[addressType].push(address);
      } else if (addressAction === "editing") {
        const addressIndex = this.company[addressType].find(
          (addr) => addr._id === address._id
        );
        this.company[addressType][addressIndex] = address;
      }
    },
    setAddAddress(type) {
      this.addressType = type;
      this.addressAction = "adding";
      this.addressModal = true;
      this.activeAddress = {
        formatted_address: null,
        address1: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        meta: {},
      };
      if (type === "shippingAddresses") {
        this.activeAddress.meta.distributorSettings = this.initializeDistributorSettings();
        this.activeAddress.meta.emailSettings = [];
      }
    },

    async getAssociates() {
      return request
        .callInternal({
          method: "get",
          route: "/api/admin/associates",
        })
        .then((results) => {
          this.associates = results.data;
        });
    },
    associateName(user) {
      return `${user.lastName}, ${user.firstName}`;
    },
    async checkUniqueUser() {
      const userEmail = get(this, "company.users[0].email" || null);
      const results = await request.callInternal({
        method: "post",
        route: "/api/checkunique",
        data: {
          model: "user",
          field: "email",
          value: userEmail,
        },
      });
      return (this.userErrorMessages = results.data
        ? []
        : ["This email is already taken"]);
    },
    setProductPrice(ctx) {
      const {
        _id,
        markup,
        customPrice,
        priceSelection,
        description,
        manufacturer,
        productCode,
      } = ctx;
      const added = this.company.individualProductPrices.find(
        (item) => item._id === _id
      );
      if (!added) {
        this.company.individualProductPrices.push({
          _id,
          priceSelection,
          customPrice,
          markup,
          description,
          manufacturer,
          productCode,
        });
        this.snackBar("Individual product added!", "success");
      } else {
        this.snackBar("Individual product already added", "error");
      }

      this.addMarkupModal = false;
    },
    setMarkupModal(product) {
      this.productMarkup = product;
      this.addMarkupModal = true;
    },
    removeMarkup(idx) {
      this.company.individualProductPrices.splice(idx, 1);
    },
    async getDistributors() {
      await request
        .callInternal({
          method: "get",
          route: "/api/admin/distributorlocations",
        })
        .then((results) => {
          this.distributors = results.data;
        })
        .catch((error) => {
          console.error(error);
          return;
        });
    },
    initializeDistributorSettings() {
      const { productCategories } = this;
      return productCategories.map((category) => {
        return {
          category: category._id,
          name: category.name,
          distributor: null,
        };
      });
    },
    clearData() {
      this.currentStep = 1;
      assign(this.company, {
        name: null,
        email: null,
        phoneNumber: null,
        billingAddresses: [],
        shippingAddresses: [],
        users: [],
        notes: null,
        categoryMarkups: [],
        subcategoryMarkups: [],
        individualProductPrices: [],
      });
    },
    async retrieveCategories() {
      const { data: categories } = await request
        .callInternal({
          method: "get",
          route: "/api/admin/fullcategories",
        })
        .catch((error) => {
          console.error(error);
        });
      this.productCategories = categories.map((category) => {
        category.value = 1.4;
        category.subcategories = category.subcategories.map((subcategory) => {
          subcategory.value = 1.4;
          return subcategory;
        });
        return category;
      });
    },
    async submit() {
      const { company, productCategories } = this;
      productCategories.forEach((category) => {
        const { value } = category;
        company.categoryMarkups.push({
          category: category._id,
          value,
        });

        category.subcategories.forEach((subcategory) => {
          const { value } = subcategory;
          company.subcategoryMarkups.push({
            subcategory: subcategory._id,
            value,
            category: category._id,
          });
        });
      });

      await request
        .callInternal({
          method: "post",
          route: "/api/admin/createcompany",
          data: company,
        })
        .then(() => {
          this.$swal({
            title: "Congratulations!",
            text: `${company.name} has been added. You may create orders for ${company.name} now.`,
            icon: "success",
          });
          this.clearData();
        })
        .catch((error) => {
          this.$swal({
            title: "Error",
            text: `Sorry, something went wrong with adding ${company.name}. Please try again or contact your system administrator.`,
            icon: "error",
          });
        });
    },
  },
};
</script>
